// extracted by mini-css-extract-plugin
module.exports = {"badge-container":"LandingPageCategoryCards_badge-container__s_c0c","badge":"LandingPageCategoryCards_badge__OB6ie"};